import React from 'react';
import { Image, StyleSheet, View, ViewStyle } from 'react-native';
import { Colors, Radii } from '../constants';
import { imageService } from '../services';

interface ClubLogoProps {
  logoUrl: string;
  size?: number;
  borderRadius?: number;
  style?: ViewStyle;
  resizeMode?: 'contain' | 'cover';
}

/**
 * Reusable club logo component with consistent styling
 * Displays logos in rounded square containers with white background
 * Supports both landscape and portrait logos using contain mode
 */
export const ClubLogo: React.FC<ClubLogoProps> = ({
  logoUrl,
  size = 32,
  borderRadius,
  style,
  resizeMode = 'contain',
}) => {
  // Design v2: club crests sit in square-shouldered white tiles. Small logos use
  // the thumbnail radius; large ones (64px+) step up to the card radius.
  const calculatedBorderRadius = borderRadius ?? (size >= 64 ? Radii.card : Radii.thumb);

  return (
    <View
      style={[
        styles.container,
        {
          width: size,
          height: size,
          borderRadius: calculatedBorderRadius,
        },
        style,
      ]}
    >
      <Image
        source={{ uri: imageService.getLogoUrl(logoUrl, 'small') }}
        style={styles.image}
        resizeMode={resizeMode}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    borderWidth: 1,
    borderColor: Colors.borderLight,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '100%',
    height: '100%',
  },
});
